import { forwardRef, useContext } from "react";
import type { SelectHTMLAttributes, ForwardedRef } from "react";
import { twMerge } from "tailwind-merge";
import { InputContext } from "./InputContext";

export const InputSelect = forwardRef(
  (
    props: SelectHTMLAttributes<HTMLSelectElement> & {
      placeholder?: string;
    },
    ref: ForwardedRef<HTMLSelectElement>,
  ) => {
    const { inputId } = useContext(InputContext);

    return (
      <select
        {...props}
        id={props.id ?? inputId}
        className={twMerge(
          "w-full cursor-pointer bg-transparent text-zinc-900 outline-0 disabled:cursor-not-allowed disabled:text-zinc-400 dark:text-zinc-100 dark:disabled:text-zinc-500",
          props.className,
        )}
        ref={ref}
      >
        {props.children}
      </select>
    );
  },
);

InputSelect.displayName = "InputSelect";
